var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40053 16.1739V11.3727C3.40053 10.9507 3.05847 10.6087 2.63652 10.6087V10.6087C1.91279 10.6087 1.5947 9.69602 2.16165 9.24617L11.5055 1.83227C11.8729 1.54078 12.3935 1.54373 12.7575 1.83937L21.785 9.17075C22.3767 9.65129 22.0369 10.6087 21.2747 10.6087V10.6087C20.8276 10.6087 20.4651 10.9711 20.4651 11.4182V21.6666C20.4651 22.2189 20.0174 22.6666 19.4651 22.6666H12.1344M3.40053 16.1739V21.6666C3.40053 22.2189 3.84825 22.6666 4.40053 22.6666H12.1344M3.40053 16.1739H5.62534C6.17762 16.1739 6.62534 16.6216 6.62534 17.1739V17.294C6.62534 17.8463 7.07305 18.294 7.62534 18.294H8.44704C8.99933 18.294 9.44704 18.7417 9.44704 19.294V19.5466C9.44704 20.0988 9.89476 20.5466 10.447 20.5466H11.1344C11.6867 20.5466 12.1344 20.9943 12.1344 21.5466V22.6666M16.1654 12.7288V19.884M16.1654 19.884L14.4186 17.1014M16.1654 19.884L17.7778 17.1014",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasement);
export default __webpack_public_path__ + "static/media/basement.a121a017e8940d987595db9fd778f980.svg";
export { ForwardRef as ReactComponent };